export enum ReceiptProvider {
  Invoice4U = 'INVOICE_4U',
  None = 'NONE',
  Verifone = 'VERIFONE',
}
